<script setup lang="ts">
import './assets/style.scss'
import { type PropType } from 'vue'
import type { GreenGladeType } from './../model/types.ts'
import { useHelpers } from '@/shared/lib'
import VGreenGladeItem from './VGreenGladeItem.vue'

defineProps({
  items: {
    type: Array as PropType<GreenGladeType[]>,
    required: true,
  },
  from: {
    type: String,
    required: true,
  },
  to: {
    type: String,
    required: true,
  },
})

const { toTimeFormat } = useHelpers()
</script>

<template>
  <div class="v-green-glade__row">
    <div></div>
    <div class="v-green-glade__dates">
      <span>{{ toTimeFormat(from, 'dd.MM.yyyy HH:mm') }}</span>
      <span>{{ toTimeFormat(to, 'dd.MM.yyyy HH:mm') }}</span>
    </div>
  </div>

  <template v-if="items.length">
    <div class="v-green-glade__list">
      <VGreenGladeItem v-for="item in items" :key="item.id" :item :from :to />
    </div>
  </template>

  <div class="v-green-glade__empty" v-else>{{ $t('itf.not_info') }}</div>
</template>
